import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationBoxComponent } from 'src/app/shared/components/confirmation-box/confirmation-box.component';

@Component({
    selector: 'configuration-group',
    templateUrl: './configuration-group.component.html',
    styleUrls: ['./configuration-group.component.scss'],
    standalone: false
})
export class ConfigurationGroupComponent implements OnInit, OnChanges {

  @Input() title: string = '';
  @Input() key: string = '';
  @Input() items: any = {};

  formValue: string = '';
  tableItems: any[] = [];
  private counter = 1;
  deleteDialogRef: MatDialogRef<ConfirmationBoxComponent>;

  @Output() values = new EventEmitter<any>();

  constructor(private dialog: MatDialog) {}

  ngOnInit() {
    this.formValue = '';
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['items'] && this.items && this.key) {
      const arr = Array.isArray(this.items[this.key]) ? this.items[this.key] : [];
      this.tableItems = arr
        .filter(v => v !== null && v !== undefined && v !== '')
        .map((value, i) => ({ index: i + 1, isEditing: false, value }));
      this.counter = this.tableItems.length + 1;
    }
  }

  emitAll() {
    const valuesArray = this.tableItems.map(item => item.value);
    this.values.emit({ [this.key]: valuesArray });
  }

  add() {
    if (!this.formValue?.trim()) return;

    const newItem = {
      index: this.counter++,
      isEditing: false,
      value: this.formValue
    };

    this.tableItems.push(newItem);
    this.emitAll();
    this.formValue = '';
  }

  edit(item: any) {
    item.isEditing = true;
  }

  save(item: any) {
    item.isEditing = false;
    this.emitAll();
  }

  delete(index: number) {
    const item = this.tableItems[index];
    this.showDeleteConfirmationBox(item.index, index);
  }

  showDeleteConfirmationBox(id: number, index: number) {
    this.deleteDialogRef = this.dialog.open(ConfirmationBoxComponent, {
      data: {
        id,
        index,
        message: `هل أنت متأكد من الحذف؟`
      }
    });

    this.deleteDialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.tableItems.splice(index, 1);
        this.emitAll();
      }
    });
  }
}
